export const getAnchorClassNameMatch = (text: string | null, className: string) => {
  const link = new RegExp(`<a.+?class=".*(${className})[ |"].*>`, 'g')

  if (!text) return null

  const match = text.split(link)

  return match[1]
}
